import { Line, LineChart, Tooltip, XAxis, YAxis } from "recharts"
import EllipsisMenu from "../../../../components/EllipsisMenu/EllipsisMenu"
import GeneralHeatmapRow from "../../../../components/GeneralHeatmapRow/GeneralHeatmapRow"
import AnalysisSection from "../AnalysisSection/AnalysisSection"
import { MetalSectionProps } from "./MetalSection.types"
import { useEffect, useState } from "react"
import { Dict } from "../../../../types/types"
import { getMode } from "../../../../utils/utils"
import SkeletonLoadingView from "../../../../components/SkeletonLoadingView/SkeletonLoadingView"

const MetalSection = (props: MetalSectionProps) => {
  const { 
    heatmapData,
    isolatedScan,
    width, 
    pixelHeight ,
    ellipsisMenu,
  } = props

  const [graphData, setGraphData] = useState<Dict[]>([])
  const [metal, setMetal] = useState<number[]>([])
  const skeletonLoadingHeight = "7rem"

  useEffect(() => {    
    if (heatmapData === undefined) { return }
    if (isolatedScan === undefined) { return }

    let startIndex = 0
    let endIndex = heatmapData.seq_nos.length - 1

    const mode = getMode(heatmapData.seq_nos)
    const sequenceNumbers = heatmapData.seq_nos.filter(data => data > 0 && Math.abs(data - mode) < 300000 )
    
    const startCalibration = sequenceNumbers.filter( sequenceNumber => sequenceNumber < isolatedScan.calibration_start_p2)
    const endCalibration = sequenceNumbers.filter( sequenceNumber => sequenceNumber > isolatedScan.calibration_end_p1)

    if (startCalibration.length > 0 && endCalibration.length > 0) {
      startIndex = sequenceNumbers.indexOf(startCalibration[startCalibration.length - 1])
      endIndex = sequenceNumbers.indexOf(endCalibration[0])
    }

    if (startIndex === -1 || endIndex === -1) {
      startIndex = 0
      endIndex = sequenceNumbers.length - 1
    }

    if (startIndex > endIndex) {
      [startIndex, endIndex] = [endIndex, startIndex]
    }

    const metal = heatmapData.metal.slice(startIndex, endIndex + 1)
    const filteredMetal = getFilteredMetal(metal)
    setMetal(filteredMetal)
    
    setGraphData(filteredMetal.map((_, i) => {
      return {
        metal: filteredMetal[i],
        amt: i
      }
    }))
  }, [heatmapData, isolatedScan])

  const getFilteredMetal = (metal: number[]) => {
    const mode = getMode(metal)
    return metal.filter((value) => Math.abs(value - mode) < 300000)
  }

  if (heatmapData === undefined || isolatedScan === undefined) {
    return (
      <AnalysisSection title="Metal">
        <div className="analysis-section">
          <SkeletonLoadingView style={{height: skeletonLoadingHeight}} />
        </div>
      </AnalysisSection>
    )
  }

  return (
    <AnalysisSection title="Metal" titleChild={
      <EllipsisMenu ellipsisMenu={ellipsisMenu} />
    }>
      <div className="analysis-section">
        <GeneralHeatmapRow
          heatmap={[metal]}
          width={width}
          pixelHeight={pixelHeight}
          colourPallate="bone"
        />
      </div>

      <div className="analysis-section">
        <LineChart
          width={width}
          height={100}
          data={graphData}
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis domain={[Math.min(...metal), Math.max(...metal)]} tick={false} axisLine={false} width={0} />
          <Tooltip />
          {/* <Legend /> */}
          <Line animationDuration={300} type="monotone" dataKey={`metal`} stroke={"grey"} dot={false} />
        </LineChart>
      </div>
    </AnalysisSection>
  )
}

export default MetalSection